<!--
 * @Author: Shber
 * @Date: 2022-07-26 14:37:06
 * @LastEditors: Shber
 * @LastEditTime: 2023-06-14 17:44:10
 * @Description:
-->
<template>
  <div class="auth_upload_title">
    <div class="title">
      <p class="title_text">
        {{ cardtypeText }} <i class="clr_brown" @click="previewShowFn">{{ imgTitleData.demoText }}</i>
      </p>
      <slot />
    </div>
    <span v-if="isReadonly" class="tip"><p class="mt_15" v-html="imgTitleData.uploadTip" /></span>

    <eDialog
      v-if="previewShow"
      class-name="dialogTip"
      :show-cancel-button="false"
      :confirm-button-text="$t('auth.nameAuth.isKnow')"
      @getConfirmEvent="getConfirmEvent"
    >
      <div class="dialog_content">
        <h3 class="fw_bold">{{ imgTitleData.dialogTitle }}</h3>
        <ul class="tip_list">
          <li v-for="(item,i) in imgTitleData.imgList" :key="i">
            <div style="flex:2"> <img :src="item.img"></div>
            <div v-if="item.tip" style="flex:1; text-align:left"><span>{{ item.tip }}</span></div>
          </li>
        </ul>
        <span class="tip bottom_tips"><span v-html="imgTitleData.uploadTip" /></span>
      </div>
    </eDialog>
  </div>
</template>
<script setup>
import eDialog from '@/components/eDialog.vue'
import { defineProps, watch, computed, ref, reactive } from 'vue'
import { useI18n } from 'vue-i18n/index'// 要在js中使用国际化
const { t } = useI18n() // 国际化方法

const previewShow = ref(false)
const identityType = ref('')
const imgTitleData = reactive({
  title: t(`auth.nameAuth.formText4`),
  demoText: t(`auth.nameAuth.formText6`),
  uploadTip: t(`auth.nameAuth.formTip1`),
  dialogTitle: t(`auth.nameAuth.formText5`),
  imgList: [
    { img: 'https://static.mingchu.co/webapp/auth/shenfen1.jpg' },
    { img: 'https://static.mingchu.co/webapp/auth/shenfen2.jpg' }
  ]
})

const props = defineProps({
  dataInfo: {
    type: Object,
    default: () => {}
  },
  dataType: { // 身份类型
    type: String,
    default: '1'
  },
  cardType: { // 卡片类型
    type: String,
    default: '1'
  },
  readonly: {
    type: Boolean,
    default: true
  }
})

const isReadonly = computed(() => props.readonly)
const cardtypeText = computed(() => {
  switch (props.cardType) {
    case '3':
      return t('auth.opnAuth.formTip3')
    case '2':
      return t('auth.opnAuth.formTip4')
    default:
      return t('auth.opnAuth.formTip2')
  }
})

watch(() => props.dataType,
  (newVal, oldVal) => {
    switch (newVal) {
      case '3':
        imgTitleData.uploadTip = t(`auth.opnAuth.formTip9`)
        identityType.value = 'haiwai'
        break
      case '2':
        imgTitleData.uploadTip = t(`auth.opnAuth.formTip9`)
        identityType.value = 'aomen'
        break
      case '4':
        imgTitleData.uploadTip = `${t(`auth.opnAuth.formTip5`)}${t(`auth.opnAuth.formTip55`)}`
        identityType.value = 'zhiye'
        break
      default:
        imgTitleData.uploadTip = t(`auth.opnAuth.formTip9`)
        identityType.value = 'shenfen'
    }
    if (newVal === '1') {
      imgTitleData.imgList = [
        { img: 'https://static.mingchu.co/webapp/auth/shenfen1.jpg' },
        { img: 'https://static.mingchu.co/webapp/auth/shenfen2.jpg' }
      ]
    } else {
      imgTitleData.imgList = [
        { img: `https://static.mingchu.co/webapp/auth/${identityType.value}1.jpg` }
      ]
    }
  },
  { immediate: true })

watch(() => props.cardType, (newVal, oldVal) => {
  // 1: '身份证', 2: '驾照', 3: '护照'
  // 1: '大陆', 2: '港澳台', 3: '海外,
  if (identityType.value === 'shenfen') {
    imgTitleData.imgList = [
      { img: 'https://static.mingchu.co/webapp/auth/shenfen1.jpg' },
      { img: 'https://static.mingchu.co/webapp/auth/shenfen2.jpg' }
    ]
  } else {
    imgTitleData.imgList = [
      { img: `https://static.mingchu.co/webapp/auth/${identityType.value}${newVal}.jpg` }
    ]
  }
  if (identityType.value === 'zhiye') {
    imgTitleData.uploadTip = t(`auth.opnAuth.formTip9`)
    switch (newVal) {
      case '3':
        imgTitleData.uploadTip = t(`auth.opnAuth.formTip7`)
        break
      case '2':
        imgTitleData.uploadTip = t(`auth.opnAuth.formTip8`)
        break
      default:
        imgTitleData.uploadTip = t(`auth.opnAuth.formTip5`) + t(`auth.opnAuth.formTip55`)
    }
  }
})

const previewShowFn = () => {
  previewShow.value = true
}

const getConfirmEvent = () => {
  previewShow.value = false
}

</script>

